import {Component, ElementRef, Input, OnDestroy, ViewChild} from '@angular/core';
import {Chart, ChartData} from "chart.js/auto";

import {ChartEvent} from "chart.js";
import {TimeseriesBarChartStore} from "../../../store/timeseries-bar-chart/timeseries-bar-chart-store";

import {TimeSeriesPerformanceStoreService} from "../../../store/time-series-performance-store.service";

import {Subscription} from "rxjs";
import {ErrorCodes} from "../../../../common/enums/states/error-codes";
import {CommonModule} from "@angular/common";
import {ErrorMessageComponent} from "../../../../common/components/error-message/error-message.component";

@Component({
  selector: 'analytics-relative-time-series-chart',
  templateUrl: './relative-time-series-chart.component.html',
  styleUrls: ['./relative-time-series-chart.component.css'],
  imports: [
    CommonModule,
    ErrorMessageComponent
  ]
})
export class RelativeTimeSeriesChartComponent implements OnDestroy {
  chart?: Chart;
  @Input() data: ChartData = {labels: [], datasets: []}
  subscription: Subscription = new Subscription();
  protected readonly ErrorAnalysis = ErrorCodes;
  private chartElement?: ElementRef<HTMLCanvasElement>;

  constructor(
    private timeSeriesBarChartStore: TimeseriesBarChartStore,
    public timeSeriesPerformanceStore: TimeSeriesPerformanceStoreService
  ) {
    this.subscribe()
  }

  @ViewChild('eventRevenueTimeSeriesChart', {static: false}) set content(content: ElementRef<HTMLCanvasElement>) {
    this.chartElement = content;
    this.createChart();
  }

  subscribe() {
    this.subscription.add(this.timeSeriesBarChartStore.updateNotifier.subscribe(
      () => {
        this.createChart();
      }
    ))
  }

  createChart() {
    if (this.chart != undefined) {
      this.chart?.destroy()
    }


    if (this.chartElement === undefined) return;
    if (this.timeSeriesBarChartStore.getRelativeBarChartDataset() === undefined) return;

    // @ts-ignore
    this.chart = new Chart(this.chartElement?.nativeElement, {
      type: 'line',
      data: this.timeSeriesBarChartStore.getRelativeBarChartDataset(),
      options: {

        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            onHover(e: ChartEvent, legendItem: any, legend: any) {
              if (legendItem === undefined) {
                legend.chart.canvas.style.cursor = 'default';
                return;
              }
              legend.chart.canvas.style.cursor = 'pointer';
            }


          },
          tooltip: {
            callbacks: {
              label: function (context: any) {
                return context.dataset.label + ': ' + context.parsed.y.toFixed(2) + '%';
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            /*min:0,
            max: 100,//this.findMax(this.data.datasets)*1.2,*/
            ticks: {
              callback: function (value: any, index: any, values: any) {
                return value + '%';
              }
            }
          }
        }
      },
    })
  }

  findMax(datasets: any[]): number {
    let max = 0;
    for (let dataset of datasets) {
      if (dataset.data === undefined) continue;
      for (let value of dataset.data) {
        if (value > max) max = value;
      }
    }
    return max;
  }

  ngOnDestroy() {
    this.chart?.destroy();
    this.subscription.unsubscribe();
  }

}
